import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import PageLayout from "examples/LayoutContainers/PageLayout";
import "./illustrationLayout.css";

import slide1 from "assets/images/login-slide-1.png";
import slide2 from "assets/images/login-slide-2.png";
import slide3 from "assets/images/login-slide-3.png";
import lynxIcon from "assets/images/lynx-icon.png";

const SLIDES = [slide1, slide2, slide3];
const INTERVAL = 4000;

function IllustrationLayout({ header, title, description, children }) {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);

  const startTimer = () => {
    timerRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % SLIDES?.length);
    }, INTERVAL);
  };

  useEffect(() => {
    startTimer();
    return () => clearInterval(timerRef.current);
  }, []);

  const goTo = (idx) => {
    clearInterval(timerRef.current);
    setCurrent(idx);
    startTimer();
  };

  return (
    <PageLayout background="white">
      <Grid container sx={{ minHeight: "100vh", background: "#fff" }}>
        {/* ── Left: carousel panel ── */}
        <Grid item xs={12} lg={6} sx={{ display: { xs: "none", lg: "block" } }}>
          <div className="ill-left-panel">
            <div className="ill-carousel">
              {SLIDES?.map((src, i) => (
                <div key={i} className={`ill-slide${i === current ? " active" : ""}`}>
                  <img src={src} alt={`slide-${i + 1}`} />
                </div>
              ))}
            </div>
            <div className="ill-dots">
              {SLIDES?.map((_, i) => (
                <div
                  key={i}
                  className={`ill-dot${i === current ? " active" : ""}`}
                  onClick={() => goTo(i)}
                />
              ))}
            </div>
          </div>
        </Grid>

        {/* ── Right: login card ── */}
        <Grid
          item
          xs={12}
          lg={6}
          sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <div className="ill-right-panel">
            <div className="ill-card">
              {/* Brand */}
              <div className="ill-brand">
                <img src={lynxIcon} alt="Lynx" className="ill-brand-icon" />
                <div className="ill-brand-text">
                  Lynx <span>by Pallet</span>
                </div>
              </div>

              <div className="ill-divider" />

              {/* Title / description or custom header */}
              {!header ? (
                <>
                  <div className="ill-title">{title}</div>
                  <div className="ill-subtitle">{description}</div>
                </>
              ) : (
                header
              )}

              {/* Form content */}
              {children}

              <div className="ill-footer">© 2025 Pallet. All rights reserved.</div>
            </div>
          </div>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

IllustrationLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  illustration: {},
};

IllustrationLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  illustration: PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
};

export default IllustrationLayout;
